export const ERRORS = {
  firstName: "First Name is required.",
  lastName: "Last Name is required.",
  email: "Email is required.",
  dob: "Date of Birth is required.",
  ssn: "Social Security Number is required.",
  validEmail: "Must be a valid email",
  street: "Street is required.",
  streetLine2: "Street Line 2 is required.",
  city: "City is required.",
  state: "State is required.",
  zipCode: "Zip Code is required.",
  filingStatus: "Filing status is required",
  bankName: "Bank Name is required",
  routingNumber: "Routing Numbe is required",
  accountNumber: "Account Number is required",
  accountType: "Account Type is required",
  filing_status: "Filing Status is required.",
  deductionAmountMaxValue: 'Deduction Amount should not be greater than 1000000000.',
  deductionAmountMinValue: 'Deduction Amount should not be less than 0.',
  dependentAmountMaxValue: 'Dependent Amount should not be greater than 1000000000.',
  dependentAmountMinValue: 'Dependent Amount should not be less than 0.',
  otherIncomeMaxValue: 'Other Income should not be greater than 1000000000.',
  otherIncomeMinValue: 'Other Income should not be less than 0.',
  withHoldingAmountMaxValue: 'Withholding Amount should not be greater than 1000000000.',
  withHoldingAmountMinValue: 'Withholding Amount should not be less than 0.',
  termsOfService: "Required", //Need to check
  expiredToken: "Expired token.",
  paymentMethod: "Payment method is required",
  signature: "Signature is required.",
  inValidDate: "Please enter a valid date.",
  dateOfHiring: "Date of hiring required",
  jobTitle: "Job title is required",
  location: "Location is required",
  amount: "Amount is required",
  elsa_status: "FLSA Status is required",
  is_owner: "Required",
  is_primary: "Required",
  share: "Number of share is required"
};
export const VIEWS = {
  toolbar: "toolbar",
  personalInfo: "personal-info",
  homeAddress: "home-address",
  stateTaxes: "state-taxes",
  federalTaxes: "federal-taxes",
  paymentMethod: "payment-method",
  reviewInfo: "review-info",
  eSign: "e-sign",
  termsOfService: "terms-of-service",
  infoSubmitted: 'info-submitted',
  personalADPInfo: "personal-adp-info",
};
export const PAGE_TITLES = {
  personalInfo: "Personal Info",
  homeAddress: "Home Address",
  federalTaxes: "Federal Taxes",
  reviewInfo: "Review Info",
  paymentMethod: "Payment Method",
  stateTaxes: "State Taxes",
  eSign: "E-Sign",
  termsOfService: "Terms of Service"
};
export const ROUTES = {
  personalInfo: "/personal-info",
  homeAddress: "/home-address",
  federalTaxes: "/federal-taxes",
  reviewInfo: "/review-info",
  paymentMethod: "/payment-method",
  stateTaxes: "/state-taxes",
  expiredLink : "/expired-link",
  termsOfService: "/terms-of-service",
  eSign: "/e-sign",
  infoSubmitted: '/info-submitted'
}

export const ADP_ROUTES = {
  personalInfo: "/personal-adp-info",
  paymentMethod: "/payment-adp-method",
  reviewInfo: "/review-adp-info",
  termsOfService: "/adp-terms-of-service",
}

export const ONBOARDING_STEPS_ROUTES = {
  personal_info: "/personal-info",
  home_address: "/home-address",
  federal_tax_info: "/federal-taxes",
  state_taxes: "/state-taxes",
  payment_method: "/payment-method",
  review_info: "/review-info",
  tos_acceptance: "/terms-of-service",
  e_sign_form: "/e-sign",
};
export const ONBOARDING_STEPS = {
  personalInfo : "personal_info",
  homeAddress: "home_address",
  federalTaxes: "federal_tax_info",
  stateTaxes: "state_taxes",
  paymentMethod: "payment_method",
  reviewInfo: "review_info",
  termsOfService: "tos_acceptance",
  eSign: "e_sign_form"
};